import React, { ReactNode } from "react";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Modal from 'react-bootstrap/Modal'
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import { withStyles, createStyles } from '@mui/styles';
import ApiFailed from '../../Utils/ApiFailed';
import ClipLoader from "react-spinners/ClipLoader";
import TextField from '@mui/material/TextField';
import { Container as BSContainer, Row as BSRow, Col as BSCol } from 'reactstrap';
import MaterialButton from '@mui/material/Button';
import { Redirect } from "react-router-dom";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import ProgressBar from "components/Progress/ProgressBar"
// DevExtreme
import { DataGrid, Column, Export, GroupPanel, Grouping, FilterRow, Pager, Paging, StateStoring, HeaderFilter } from 'devextreme-react/data-grid';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Chip, useTheme } from '@mui/material';
import deMessages from "devextreme/localization/messages/de.json";
import frMessages from "devextreme/localization/messages/fr.json";
import esMessages from "devextreme/localization/messages/es.json";
import ptMessages from "devextreme/localization/messages/pt.json";
import { locale, loadMessages } from "devextreme/localization";
import { injectIntl, FormattedMessage } from 'react-intl';
//Moment date/time formatting
//https://momentjs.com/docs/
import moment from 'moment';
import { adjustTime } from '../../Utils/AdjustTime'

import { CreateUrl, CallGetAPI, CallPostAPI } from 'Utils/ApiHelper.js';
import dxDataGrid, { dxDataGridRowObject } from "devextreme/ui/data_grid";

import { isLCLLogger } from 'variables/chariotProductIds';
import { APIGetFirmwaresModel } from '../../models/APIGetFirmwaresModel';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { GutermannModelConverter, GutermannModelDeConverter } from "../../Utils/GutermannModelCoverter";
import { Call } from "@mui/icons-material";
import Loader from '../../Utils/Loader/NewLoader2025'

const styles: Record<string, any> = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    }
};

let modalTitle = "";

const style = createStyles(styles);

interface DeviceData {
    id: number;
    serial: string;
    site: string;
    model: string;
    channels: string;
    lastConnected: Date | null;
    alarmState: string;
    siteId: number | null;
    siteName: string;
    currentFw: string;
    availableFw: string;
    company: string;
    firmwareToUpdate: number | null;
    firmwareSent: number | null;
    firmwareConfirmed: Date | null;
    firmwareSize: number | null;
}

interface Props {
    classes: {
        cardTitleWhite: string;
        cardCategoryWhite: string;
    };
    history: {
        showBackButton: boolean;
        goBack: () => void;
    };
}

interface State {
    loading: boolean;
    tableHidden: boolean;
    authorized: boolean;
    visible: boolean;
    selectedLogger: number;
    devices: Array<DeviceData>;
    filterValue: Array<string | string[]>;
    tempDevice: DeviceData | undefined;
    anchorEl: EventTarget & HTMLButtonElement | null;
    deleteModal: boolean;
    modal: boolean;
    redirect: boolean;
    redirectPath: string | undefined;
    redirectProps: { serial: string | undefined; deviceId: number | undefined } | undefined;
    updateModal: boolean;
    firmwares: Array<APIGetFirmwaresModel>;
    firmwareId: number;
}

class FirmwareUpdates extends React.Component<Props, State> {

    gridRef: React.RefObject<DataGrid>;

    constructor(props: Props | Readonly<Props>) {
        super(props);
        // Ref to Datagrid to store Page, Sort & Filters
        this.gridRef = React.createRef();
        locale(sessionStorage.getItem('language'));
        loadMessages(frMessages);
        loadMessages(deMessages);
        loadMessages(esMessages);
        loadMessages(ptMessages);
        this.state = {
            tableHidden: false,
            visible: false,
            selectedLogger: 0,
            devices: [],
            loading: true,
            authorized: true,
            filterValue: [],
            tempDevice: undefined,
            anchorEl: null,
            deleteModal: false,
            modal: false,
            redirect: false,
            redirectPath: undefined,
            redirectProps: undefined,
            updateModal: false,
            firmwares: [],
            firmwareId: 0,
        };

    }
    get dataGrid(): dxDataGrid | undefined {
        return this.gridRef.current?.instance;
    }

    createSuccessNotification = (msg: string): void => {
        NotificationManager.success(msg, this.props.intl.formatMessage({ id: 'Success' }));

    };

    createErrorNotification = (type: string): void => {
        NotificationManager.error(this.props.intl.formatMessage({ id: 'Error Saving ' }) + type, this.props.intl.formatMessage({ id: 'Check console' }), 5000, () => {
            alert('callback');
        });
    };

    componentDidMount(): void {
        const deviceData = new Array<DeviceData>();
 
        const me = this;

        CallGetAPI(CreateUrl('/api/aquaguard/GetFirmwareUpdateLoggers?companyId=' + sessionStorage.getItem('companyId') + '&filterGroup=' + sessionStorage.getItem('filterGroupId') + "&deployed=false"),{})
            .then(data => {
                if (data?.length > 0) {

                    // Copy the data records into deviceData, adding the clickEvent
                    deviceData.length = 0; //clear dummy data
                    for (let i = 0; i < data.length; i++) {

                        if (window.location.hostname.includes('zonelog.net')) {
                            data[i].model = GutermannModelConverter(data[i].model)
                        }
                        const serial = data[i].serial;
                        const id = parseInt(data[i].id);
                        const rec: DeviceData = {
                            id: id,
                            serial: serial,
                            site: data[i].site.replace(/[^A-Za-z0-9]/g, ''),
                            model: data[i].model,
                            channels: data[i].channels,
                            lastConnected: data[i].lastConnected? adjustTime(moment(data[i].lastConnected).toDate()) : null,
                            alarmState: data[i].alarmState.toString(),
                            siteId: data[i].siteId,
                            siteName: data[i].siteName,
                            currentFw: data[i].currentFirmware,
                            availableFw: data[i].availableFirmware,
                            company: data[i].company,
                            firmwareToUpdate: data[i].firmwareToUpdate,
                            firmwareSent: data[i].firmwareSent,
                            firmwareConfirmed: adjustTime(data[i].firmwareConfirmed),
                            firmwareSize: data[i].firmwareSize,
                        };
                        deviceData.push(rec);
                    }

                    me.setState(
                        {
                            devices: deviceData,
                            tableHidden: false,
                            loading: false
                        })
                }
                else {
                    me.setState(
                        {
                            devices: [],
                            tableHidden: false,
                            loading: false
                        })
                }
            })
            .catch(function () {
                me.setState(
                    {
                        authorized: false
                    })
            });
            
    }

    handleClick(event: React.MouseEvent<HTMLButtonElement, MouseEvent>, id: dxDataGridRowObject): void {   //React.MouseEvent<HTMLButtonElement, MouseEvent>
        const device = this.state.devices.find((row) => row.id === id.key);

        this.setState(
            {
                tempDevice: device,
                anchorEl: event.currentTarget
            });
    }

    toggleModal = (): void => {
        this.setState({
            modal: !this.state.modal
        });
    }

    //edit row
    editDevice = (): void => {
        this.setState({
            modal: !this.state.modal,
            anchorEl: null
        });
        modalTitle = "Edit Device"
    }

    toggleDeleteModal = (): void => {
        this.setState({
            deleteModal: !this.state.deleteModal,
            anchorEl: null
        });
        modalTitle = "Warning"
    }

    handleClose = (): void => {
        this.setState({ anchorEl: null });
    }

    deleteRow = (): void => {

        const rows = this.state.devices

        const device = this.state.devices.find((device) => device.id === this.state.tempDevice?.id);

        //remove the old version of the row
        const filteredRows = rows.filter(function (row) { return row.id !== device?.id });


        this.setState({
            deleteModal: !this.state.deleteModal,
            devices: filteredRows
        });
    }

    //field changed events---
    deviceSiteChanged = (event: any): void => {
        const tempDevice = this.state.tempDevice;
        if (tempDevice) {
            tempDevice.site = event.target.value;
            this.setState({ tempDevice: tempDevice });
        }
    }

    //-------------------------

    //save changes, for both edit and new
    saveDevice = (): void => {

        const device = this.state.devices.find((device) => device.id === this.state.tempDevice?.id);
        const rows = this.state.devices

        if (device && this.state.tempDevice) {
            const deviceIndex = rows.indexOf(device);

            rows.splice(deviceIndex, 1, this.state.tempDevice);

            this.setState({
                modal: !this.state.modal,
                devices: rows
            });
        }

        //********************
        //send model to API


    }
    //do nothing, close the modal
    cancel = (): void => {
        this.toggleModal();
    }

    deviceDetailsClick = (): void => {

        this.setState(
            {
                redirect: true,
                //redirectPath: this.state.tempDevice?.model != "LCL" ? '/portal/DeviceDetail' : '/portal/LCLDeviceDetail',
                redirectPath: !isLCLLogger(this.state.tempDevice?.model) ? '/portal/DeviceDetail' : '/portal/LCLDeviceDetail',
                redirectProps: {
                    serial: this.state.tempDevice?.serial,
                    deviceId: this.state.tempDevice?.id
                }
            });
    }

    deviceOverviewClick = (serial: number | null, model: string | null): void => {
        this.setState(
            {
                redirect: true,
                //redirectPath: this.state.tempDevice?.model != "LCL" ? '/portal/DeviceDetail' : '/portal/LCLDeviceDetail',
                redirectPath: !isLCLLogger(model ? model : this.state.tempDevice?.model) ? '/portal/DeviceDetail' : '/portal/LCLDeviceDetail',
                redirectProps: {
                    serial: typeof (serial) === 'number' ? serial : this.state.tempDevice?.serial,
                    mapKey: this.props.mapKey
                }
            });
    }

    deviceFirmwareClick = async (): Promise<void> => {
        modalTitle = this.props.intl.formatMessage({ id: "Trigger Firmware update" });

        let model = this.state.tempDevice?.model;

        if (isLCLLogger(model)) {
            try {
                const data = await CallGetAPI(CreateUrl(`/api/aquaguard/LCLogger?id=${this.state.tempDevice.id}`), {});
                model = data.productId;
            } catch (err) {
                this.createErrorNotification(this.props.intl.formatMessage({ id: 'Error Getting Firmware updates' }));
                return; // Stop execution if model fetching fails
            }
        }

        try {
            const data = await CallGetAPI(CreateUrl(`/api/aquaguard/Firmware?model=${model}`), {});
            if (data.length > 0) {
                const records = data.map((item: APIGetFirmwaresModel) => item);
                this.setState({
                    updateModal: true,
                    firmwares: records,
                    anchorEl: null
                });
            } else {
                this.setState({ firmwares: [] });
            }
        } catch (error) {
            this.setState({ firmwares: [] });
        }
    };


    toggleUpdateModal = (): void => {
        this.setState({
            updateModal: !this.state.updateModal,
            anchorEl: null
        });
        modalTitle = this.props.intl.formatMessage({ id: "Warning" })
    }

    handleFirmwareChange = (e: any): void => {

        const inputValue: string = e.target.value;

        this.setState({ firmwareId: parseInt(inputValue) });
    }

    doUpdate = (): void => {

        const me = this;

        //Call API to update the firmware
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ firmwareId: this.state.firmwareId, serial: this.state.tempDevice?.serial,  })
        };
        console.log(requestOptions)
        CallPostAPI(CreateUrl('/api/Aquaguard/SendChariotFirmware'), requestOptions)
            .then(response => {
                console.log(response)
                if (response.ok) {
                    me.createSuccessNotification(this.props.intl.formatMessage({ id: 'Device firmware will be updated' }));
                }
                else {
                    me.createErrorNotification(this.props.intl.formatMessage({ id: 'Error Saving Firmware updates' }));
                }

            })
            .catch(function (error) {
                me.createErrorNotification(this.props.intl.formatMessage({ id: 'Error Saving Firmware updates' }));
                console.log(error);
            });

        this.setState(
            {
                updateModal: false,
            });
    }
    dateColumnCustomizeText(cellInfo: any): string {
        if (cellInfo.value == null)
            return "";
        else
            return moment(cellInfo.value).format("DD/MM/YYYY HH:mm:ss");
    }

    onExporting(e: any): void {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('FirmwareAvailable');

        exportDataGrid({
            component: e.component,
            worksheet: worksheet
        }).then(function () {
            workbook.xlsx.writeBuffer()
                .then(function (buffer: Buffer) {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), window.location.hostname.includes('zonelog.net') ? 'ZONELOG Export.xlsx':'Aquaguard Export.xlsx');
                });
        });
        e.cancel = true;
    }

    

    renderProgress(item: any): ReactNode {
        if (item == null)
            return <div></div>;
        else {

            if (item.data.model.startsWith("CH") && this.props) {
                if (item.data.firmwareConfirmed != null && item.data.firmwareSent == null) {
                    return <div>{this.props.intl?.formatMessage({ id: 'Confirmed' })}</div>;
                }
                else {
                    if (item.data.firmwareToUpdate != null) {
                        if (item.data.firmwareSent == null || item.data.firmwareSent == 0) {
                            return <div>{this.props?.intl.formatMessage({ id: 'Requested' })}</div>;
                        }
                        else {
                            const size = item.data.firmwareSize == null ? 1 : item.data.firmwareSize + 1;
                            const percent = Math.round(item.data.firmwareSent * 100 / size);
                            return <div>
                                <div>{this.props?.intl.formatMessage({ id: 'In progress' })}</div>
                                <ProgressBar progress={percent} />
                            </div>;
                        }
                    }
                    else {
                        return <div>{this.props?.intl.formatMessage({ id: 'Pending' })}</div>;
                    }
                }
            }
            else {
                return <div></div>;
            }

        }
    }

    moreRender(key: dxDataGridRowObject): ReactNode {
        return (
            <IconButton size="small" onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => { this.handleClick(e, key); }}><MoreHorizIcon /></IconButton>
        );
    }

    serialColumnTemplate(item: any): ReactNode {
        const theme = useTheme();

        if (item == null) return <div></div>;
        else {
            return <div style={{ float: "right" }}>
                <Chip
                    label={item.data.serial}
                    sx={{ backgroundColor: theme.palette.grey.main, color: theme.palette.grey.contrastText }}
                    onClick={(): void => this.deviceOverviewClick(item.data.serial, item.data.model)}
                />
            </div>
        }
    }

    handleLatest(): void {

        this.setState({ firmwareId : this.state.firmwares[this.state.firmwares.length - 1].id})
    }

    render(): ReactNode {
        const { classes, intl } = this.props;

        return (this.state.authorized) ? //if we are authorized, show page, else redirect to login page
            (
                 (!this.state.redirect) ?
                (<div>
                        
                        <Modal
                            show={this.state.updateModal}
                            onHide={(): void => this.toggleUpdateModal()}
                            dialogClassName="modal-25w"
                            aria-labelledby="example-custom-modal-styling-title"
                            centered
                        >
                            <Modal.Header closeButton>
                                <Modal.Title id="example-custom-modal-styling-title">
                                    {modalTitle}
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body className="show-grid">
                                <div style={{width: "100%"} }>
                                    <div style={{display: "flex", justifyContent: "space-around"} }>
                                        <p style={{ marginTop: "4px" }}>{intl.formatMessage({ id: 'Logger you are updating the firmware of:' })} </p>
                                        <Chip
                                            label={this.state.tempDevice?.serial}
                                            color="primary"
                                        /> 
                                    </div>
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                    <div>
                                        <div>
                                                <MaterialButton variant="contained" color="warning" onClick={(): void => { this.handleLatest() }}>{intl.formatMessage({ id: 'Get latest version' })}</MaterialButton>
                                        </div>
                                    
                                    
                                            <p style={{ marginTop: "10px", textAlign: "center" }}>{intl.formatMessage({ id: 'Or select a version' })}</p>
                                            <div style={{display: "flex", justifyContent: "space-around", marginTop: "-5px"} }>
                                            <Select
                                                name="Firmware"
                                                style={{ margin: 0, paddingBottom: 0 }}
                                                value={this.state.firmwareId}
                                                onChange={this.handleFirmwareChange.bind(this)}
                                                size="small"
                                            >
                                                {
                                                    this.state.firmwares.map(fw => {
                                                        return <MenuItem key={fw.id} value={fw.id}>{fw.versionStr}</MenuItem>
                                                })
                                                }
                                            </Select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <MaterialButton color="primary" variant="contained" style={{ marginRight: "10px" }} disabled={this.state.firmwareId == 0} onClick={(): void => this.doUpdate()}>{intl.formatMessage({ id: 'Continue' })}</MaterialButton>
                                <MaterialButton color="secondary" variant="contained" onClick={(): void => this.toggleUpdateModal()}>{intl.formatMessage({ id: 'Cancel' })}</MaterialButton>
                            </Modal.Footer>
                        </Modal>

                        {this.state.loading &&
                            <div style={{
                                position: 'absolute', left: 'Calc(50% - 100px)', top: '50%',
                                transform: 'translate(-50%, -50%)',
                                zIndex: 13000
                            }}>
                                <Loader color={undefined } />
                            </div>
                        }
                    {!this.state.loading &&
                        <div>

                            {this.state.tableHidden &&


                                    <ApiFailed />
                            }
                            {!this.state.tableHidden &&
                                    <GridContainer>
                                        {console.log(this.state.updateModal) }
                                    <GridItem xs={12} sm={12} md={12}>
                                        <Card>
                                        <CardHeader color="primary" className="view view-cascade  d-flex justify-content-between align-items-center">
                                            <div style={{ marginLeft: "7px" }}>
                                                    <h4 style={{ display: 'inline' }} className={classes.cardTitleWhite}>{intl.formatMessage({ id: 'Available Firmware updates' })}</h4>
                                                <p className={classes.cardCategoryWhite}>
                                                    {intl.formatMessage({ id: 'Devices where newer firmware is available.' })}
                                                </p>
                                            </div>
                                            </CardHeader>
                                            <CardBody>
                                                    {this.state.devices.length > 0 && <DataGrid
                                                        dataSource={this.state.devices}
                                                        keyExpr="id"
                                                        ref={this.gridRef}
                                                        defaultFilterValue={this.state.filterValue}
                                                        onExporting={this.onExporting}
                                                        allowColumnResizing={true}
                                                        allowColumnReordering={true}
                                                    >
                                                        <StateStoring enabled={true} type="localStorage" storageKey="firmwareListGrid" />
                                                        <Export enabled={true} />
                                                        <GroupPanel visible={true} />
                                                        <Grouping autoExpandAll={true} />
                                                        <FilterRow visible={true} />
                                                        <HeaderFilter visible={true} />
                                                        <Column dataField="id" visible={false} dataType="number" />
                                                        <Column caption="Company" dataField="company" dataType="string" groupIndex={0} />
                                                        <Column dataField="serial" dataType="string" caption={intl.formatMessage({ id: 'Serial' })} cellRender={this.serialColumnTemplate.bind(this)} />
                                                        <Column dataField="siteNameUserFriendly" caption={intl.formatMessage({ id: "Site Name" })} dataType="string" />
                                                        <Column dataField="siteName" caption={intl.formatMessage({ id: "Site Ref" })} dataType="string" />
                                                        <Column caption={intl.formatMessage({ id: 'Model' })} dataField="model" dataType="string" />
                                                        <Column dataField="currentFw" dataType="string" caption={intl.formatMessage({ id: "Current Version" })} />
                                                        <Column dataField="availableFw" dataType="string" caption={intl.formatMessage({ id: "Available update" })} />
                                                        <Column dataType="string" caption={intl.formatMessage({ id: "Progress" })} allowFiltering={false} cellRender={this.renderProgress} />
                                                        <Column type="buttons" cellRender={this.moreRender.bind(this)} fixed={true} fixedPosition="right" />
                                                        <Pager allowedPageSizes={[10, 20, 50, 200]} showPageSizeSelector={true} />
                                                        <Paging defaultPageSize={10} />
                                                    </DataGrid>}
                                            </CardBody>
                                        </Card>
                                    </GridItem>
                                </GridContainer>
                            }
                        </div>
                    }
                    <Menu
                        id="simple-menu"
                        anchorEl={this.state.anchorEl}
                        keepMounted
                        open={Boolean(this.state.anchorEl)}
                        onClose={this.handleClose}
                    >
                    <MenuItem onClick={this.deviceOverviewClick}>{intl.formatMessage({id: 'Overview' })}</MenuItem>
                    {isLCLLogger(this.state.tempDevice?.model) && sessionStorage.getItem('canConfig') === 'true' &&
                    <MenuItem onClick={this.deviceFirmwareClick}>{intl.formatMessage({ id: 'Update Firmware' })}</MenuItem>
                        }
                    </Menu>
                </div>)
                :
                 (<Redirect push to={{
                    pathname: this.state.redirectPath,
                    state: this.state.redirectProps
                }}/>)
            )
            :
            (
                <Redirect to={'/Login'} />
            );
    }
}

export default injectIntl(withStyles(style)(FirmwareUpdates))

